export const DATE_MMM_DD_YYYY = 'MMM DD, YYYY';
export const DATE_MMM_DD = 'MMM, DD';

export const ALL_USERS_ID = 0;
export const USERS_WITHOUT_GROUP_ID = 1;
export const USERS_IN_GROUP_ID = 2;
